<div class="text-center">
  <h6 class="m-0 pb-1">{{ title }}</h6>
  <div mat-dialog-content>
    <mat-spinner [style.margin]="'auto'"></mat-spinner>
  </div>
</div>
